var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0854 22.2205C16.3422 23.2641 14.3029 23.8639 12.1234 23.8639C5.70396 23.8639 0.5 18.66 0.5 12.2406C0.5 5.82115 5.70396 0.617188 12.1234 0.617188C14.3028 0.617188 16.3422 1.21703 18.0854 2.26064L35.3711 12.2406L18.0854 22.2205Z",
    fill: "#FF2B06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingIcon);
export default __webpack_public_path__ + "static/media/upcomingIcon.350b5fc7261c2b201ffbb5995918aa5f.svg";
export { ForwardRef as ReactComponent };